import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import { userApi } from '@/api'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: '',
    userInfo: null,
    directCount: 0,
    totalCount: 0
  },
  getters: {
    isLoggedIn: state => !!state.token,
    userType: state => state.userInfo ? state.userInfo.userType : null,
    isAdmin: state => state.userInfo && state.userInfo.userType === '0',
    isMember: state => state.userInfo && state.userInfo.userType === '1',
    userId: state => state.userInfo ? state.userInfo.userId : null,
    shareCode: state => state.userInfo ? state.userInfo.shareCode : null
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
    },
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
    },
    SET_COUNTS(state, { directCount, totalCount }) {
      state.directCount = directCount
      state.totalCount = totalCount
    },
    CLEAR_ALL(state) {
      state.token = ''
      state.userInfo = null
      state.directCount = 0
      state.totalCount = 0
    }
  },
  actions: {
    // 登录
    async login({ commit }, { phone, password }) {
      const res = await userApi.login({ phone, password })
      commit('SET_TOKEN', res.data.token)
      commit('SET_USER_INFO', res.data.user)
      return res.data
    },

    // 注册
    async register({ commit }, userData) {
      const res = await userApi.register(userData)
      commit('SET_TOKEN', res.data.token)
      commit('SET_USER_INFO', res.data.user)
      return res.data
    },

    // 获取用户信息
    async fetchUserInfo({ commit }) {
      const res = await userApi.getUserInfo()
      commit('SET_USER_INFO', res.data.user)
      commit('SET_COUNTS', {
        directCount: res.data.directCount,
        totalCount: res.data.totalCount
      })
      return res.data
    },

    // 退出登录
    logout({ commit }) {
      commit('CLEAR_ALL')
    }
  },
  plugins: [createPersistedState({
    storage: window.localStorage,
    paths: ['token', 'userInfo']
  })]
})
